<template>
  <nav class="mobile-nav">
    <button
      type="button"
      :class="[
        'mobile-nav-btn',
        { 'mobile-nav-btn--active': activeTab === 'dashboard' },
      ]"
      @click="$emit('change-tab', 'dashboard')"
    >
      <span class="icon">📊</span>
      <span class="label">Início</span>
    </button>

    <button
      type="button"
      :class="[
        'mobile-nav-btn',
        { 'mobile-nav-btn--active': activeTab === 'values' },
      ]"
      @click="$emit('change-tab', 'values')"
    >
      <span class="icon">🏅</span>
      <span class="label">Valores</span>
    </button>

    <button
      type="button"
      :class="[
        'mobile-nav-btn',
        { 'mobile-nav-btn--active': activeTab === 'communication' },
      ]"
      @click="$emit('change-tab', 'communication')"
    >
      <span class="icon">💬</span>
      <span class="label">Chat</span>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'CulturaMobileBottomNav',
  props: {
    activeTab: {
      type: String,
      default: 'dashboard',
    },
  },
}
</script>

<style scoped>
.mobile-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  padding: 6px 0;
  z-index: 1000;
}

/* Esconde no desktop */
@media (min-width: 768px) {
  .mobile-nav {
    display: none;
  }
}

.mobile-nav-btn {
  border: none;
  background: transparent;
  padding: 4px 6px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: #94a3b8;
  font-size: 10px;
  cursor: pointer;
}

.mobile-nav-btn--active {
  color: #2563eb;
}

.icon {
  font-size: 18px;
}
</style>
